import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Youtube = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <g clipPath="url(#clip0_5133_2647)">
        <path
          d="M14.3921 4.77426C14.2383 4.19983 13.788 3.74692 13.2169 3.59227C12.1735 3.30505 8.00001 3.30505 8.00001 3.30505C8.00001 3.30505 3.8265 3.30505 2.78312 3.58122C2.22299 3.73587 1.76171 4.19983 1.60795 4.77426C1.33337 5.82369 1.33337 7.99989 1.33337 7.99989C1.33337 7.99989 1.33337 10.1871 1.60795 11.2255C1.76171 11.7999 2.21201 12.2529 2.78312 12.4075C3.83748 12.6947 8.00001 12.6947 8.00001 12.6947C8.00001 12.6947 12.1735 12.6947 13.2169 12.4186C13.788 12.2639 14.2383 11.811 14.3921 11.2366C14.6667 10.1871 14.6667 8.01094 14.6667 8.01094C14.6667 8.01094 14.6776 5.82369 14.3921 4.77426Z"
          fill="#FF0000"
        />
        <path d="M10.1425 7.99975L6.67188 5.98926V10.0102L10.1425 7.99975Z" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_5133_2647">
          <rect width="13.3333" height="10.6667" fill="white" transform="translate(1.33337 2.66669)" />
        </clipPath>
      </defs>
    </svg>
  )
})

export default Youtube
